const companyReducer = (state=null, action) => {
    switch (action.type) {
        case 'SET_COMPANY' :
            return action.payload;
        case 'CLEAR_COMPANY' :
            return null;
        default:
            return state;
    }
};

export default companyReducer